import moment from 'moment'

export function shortDate (value) {
  return moment(value).format('MM/DD/YYYY hh:mm:ssa')
}



// WEBPACK FOOTER //
// ./src/filters/dates.js